import { styled } from 'linaria/react';

export const UserWithLoyaltyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-150);

  width: fit-content;
  padding: var(--space-50) var(--space-200) var(--space-50) var(--space-50);
  border: 1px solid var(--control-minor);
  border-radius: 100px;
`;
